import React from 'react';
import { get } from 'lodash';
import moment from 'moment';

const HUMANIZED_CLASSIFICATIONS = {
  paid_shift: 'Shift completed',
  decommit: 'Decommitted',
  streak_5: '5-shift streak reached',
  streak_10: '10-shift streak reached',
  streak_25: '25-shift streak reached',
  streak_50: '50-shift streak reached',
  streak_25_over_50: '25-shift streak reached',
  streak_repeat: 'Repeat streak reached',
  '24h_coverage': 'Short-notice coverage',
  '48h_coverage': 'Short-notice coverage',
  callout_3_to_7_days: 'Callout, 7–3 days notice',
  callout_24_to_72_hours: 'Callout, 72–24 hours notice',
  callout_under_24_hours: 'Callout, under 24 hours notice',
  no_show: 'No-show',
  no_show_expired: 'Penalty expired',
  callout_3_to_7_days_expired: 'Penalty expired',
  callout_24_to_72_hours_expired: 'Penalty expired',
  callout_under_24_hours_expired: 'Penalty expired',
};

const RecentActivityBlock = ({ statistics }) => {
  const { last6MonthsJobCount, reliability } = statistics;
  const reliabilityLogs = get(reliability, 'reliabilityLogs', [])
    .slice()
    .sort((a, b) => new Date(b.occurredAt) - new Date(a.occurredAt));

  return (
    <div className="recent-activity-block">
      <div className="recent-activity-block__heading">
        <span className="recent-activity-block__title">Recent Go4 Activity</span>
        <span className="recent-activity-block__period">Last 6 months</span>
      </div>

      <div className="recent-activity-block__shifts-pill">
        <span className="material-icons-outlined" style={{ fontSize: 22, color: '#3A9C95' }}>
          event_available
        </span>
        <span className="recent-activity-block__shifts-number">{last6MonthsJobCount}</span>
        <span className="recent-activity-block__shifts-label">
          {last6MonthsJobCount === 1 ? 'shift' : 'shifts'} worked
        </span>
      </div>

      <div className="recent-activity-block__factors-heading">SCORE FACTORS</div>

      <div className="recent-activity-block__factors-list">
        {reliabilityLogs.map((log, i) => {
          const positive = log.impact >= 0;

          return (
            <div key={i} className="recent-activity-block__factor-item">
              <div className="recent-activity-block__factor-content">
                <div className="recent-activity-block__factor-label">
                  {get(HUMANIZED_CLASSIFICATIONS, log.classification, '')}
                </div>
                <div className="recent-activity-block__factor-meta">
                  {moment(log.occurredAt).format('MMM D')}
                </div>
              </div>
              <span
                className={`recent-activity-block__factor-pts ${
                  positive
                    ? 'recent-activity-block__factor-pts--pos'
                    : 'recent-activity-block__factor-pts--neg'
                }`}
              >
                {log.impact}
              </span>
            </div>
          );
        })}
      </div>

      <div className="recent-activity-block__note">Penalties age out 6 months after the incident.</div>
    </div>
  );
};

export default RecentActivityBlock;
